// extracted by mini-css-extract-plugin
export default {"fragmentsButton":"styles_fragmentsButton__CQET9","background":"styles_background__NRmSi","yellow":"styles_yellow__6HbQF"};